import React from "react";
import styled from "styled-components";
import Styles from "../../utils/styles";
import Colors from "../../utils/colors";

const LabelElement = styled.label`
  font-family: ${Styles.FONTS.FONT_BOLD};
  font-size: 1.2rem;
  color: #808080 !important;
`;

const Error = styled.div`
  color: ${Colors.RED} !important;
  height: 10px;
  margin-top: 1px;
  text-transform: uppercase;
  margin-left: 20px;
  line-height: var(--nano-line-height);
  font-size: var(--nano-font-size);
`;

const FormControl = styled.div`
  padding: 8px 0;
  color: white;
  display: flex;

  .inner {
    display: flex;
    width: 100%;
    flex-direction: column;
    position: relative;
  }

  input.input,
  textarea.input,
  select {
    border: none;
    background: #f1f1f1;
    width: 100%;
    box-sizing: border-box;
    font-family: ${Styles.FONTS.FONT_REGULAR};
    font-size: var(--small-font-size);
    color: #808080;
    padding: 10px;
    outline: none;
    appearance: none;
    border-radius: 10px;
  }

  .check {
    margin: 0 20px 0px 20px;
  }

  .no-margin {
    margin: 0 !important;
  }
`;

export const Input = ({
  type = "text",
  label,
  noLabel = false,
  name,
  id,
  maxLength = 100,
  inputRef,
  errors,
  style,
  inputClass = "",
  value = "",
  useForm = true,
  disabled = false,
  defaultValue,
  Icon,
  labelClass = "",
  onChange = () => null,
}) => (
  <FormControl style={style}>
    {Icon && (
      <Icon
        width={30}
        height={30}
        style={{ marginRight: "10px", alignSelf: "start" }}
      />
    )}
    <div className="inner">
      {!noLabel && type !== "checkbox" && (
        <LabelElement className={labelClass} htmlFor={id}>
          {label}
        </LabelElement>
      )}
      {type !== "textarea" && type !== "select" && type !== "checkbox" && (
        <input
          className={"input " + inputClass}
          type={type}
          name={name}
          id={id}
          disabled={disabled}
          defaultValue={defaultValue}
          ref={inputRef}
          maxLength={maxLength}
          onChange={onChange}
        />
      )}
      {type === "checkbox" && (
        <>
          <input
            type="checkbox"
            className={"check"}
            name={name}
            id={id}
            disabled={disabled}
            onChange={onChange}
            ref={inputRef}
          />
          <label className={labelClass} htmlFor={id}>
            {label}
          </label>
        </>
      )}
      {type === "select" && (
        <select id={id} name={name} ref={inputRef} onChange={onChange}>
          <option value="unique">Única</option>
          <option value="quarterly">Trimestral</option>
        </select>
      )}
      {type === "textarea" && useForm && (
        <textarea
          className={"input " + inputClass}
          ref={inputRef}
          name={name}
          id={id}
          maxLength={maxLength}
        />
      )}
      {type === "textarea" && !useForm && (
        <textarea
          className={"input " + inputClass}
          name={name}
          id={id}
          value={value}
          onChange={({ target: { value } }) => {
            onChange(value);
          }}
          maxLength={maxLength}
        />
      )}

      <Error style={{ color: "red" }}>{errors && errors.message}</Error>
    </div>
  </FormControl>
);
